import React, { useEffect, useRef, useState } from "react";

import Autocomplete from "react-google-autocomplete";
import { useDispatch, useSelector } from "react-redux";

import { Box, Button } from "@mui/material";

import PropertyForm from "./PropertyForm";
import { Loader } from "../../common/loader";
import AlertDialog from "../../common/AlertDialog";
import {
  decryptPayload,
  getObjLength,
  getShortNameAddressFromGoogleAutoComplete,
  normalizePropertySearchPayload,
  normalizeUsStateValue,
} from "../../helpers/utils";
import { setPropertySearchModeFromPayload } from "../../helpers/enhancedMonitoringSearchRules";
import { getEldoradoCountyRestrictionMessage } from "../../helpers/eldoradoSignup";
import { ROLES } from "../../helpers/constants";
import { userSigupAction } from "../../../redux/slices/user/userSignUpSlice";
import { propertiesAction } from "../../../redux/slices/properties/propertiesSlice";
import FindPropertyByAddressV2 from "../../user-signup/SignupTaiwindComponents/FindPropertyByAddressV2";

export default function FindProperty({
  onBtnClick,
  onChangeModalScreen,
  isByPassOptionAvailable = false,
  isAdminCreateUser = false,
  isServiceProvider = false,
  onCloseModalHandler,
  setShowPropertyListing,
  propertyValues,
  setPropertyValues,
  // setQuestionsErrMsg ,
  questionsErrMsg,
  open,
  setErrMsg,
  errMsg,
  handleClose,
  validate,
  handleToggle,
  editProperty = false,
  selectedData = {},
  address = "",
  isResumeSignup = false,
  selectedRowData = {},
  isAssistant = false,
  backToCategoryWisePricingScreen = () => {},
  isAdmin = false,
  searchedAddress = {},
  setSearchedAddress = () => {},
  userEmail = undefined,
  hasSearched = false,
  isTailwindComponent = false,
  isPropertyConfirmed,
  agreementCategory = undefined,
}) {
  const propertyErrorRef = useRef(null);
  const questionsErrorRef = useRef(null);
  const [otherPropertyValues, setOtherPropertyValues] = useState({});
  const [existingAdd, setExistingAdd] = useState(editProperty ? address : "");
  const [editAdd, setEditAdd] = useState({});
  const role = decryptPayload(localStorage.getItem("roles"));
  const agent_role = decryptPayload(localStorage.getItem("agent_role"));
  const [addressPopup, setAddressPopup] = useState(
    role?.includes(ROLES.admin) ||
      role?.includes(ROLES.subAdmin) ||
      agent_role?.includes(ROLES.assistant)
      ? localStorage.getItem("searched_Add_popup")
      : false,
  );
  console.log("addressPopup==>", agent_role?.includes(ROLES.assistant));

  const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

  const stateCodesData = useSelector(
    (state) => state.signUpUser.statesCodeList,
  );
  const statesLoader = useSelector((state) => state.signUpUser.statesLoader);
  const { getPropertyData, editPropertiesDetails, propertyQuestion } =
    useSelector((state) => state.properties);

  const dispatch = useDispatch();

  const handleChange = (place) => {
    setEditAdd({});
    var address = place.formatted_address;
    console.log("Place values==?>", place);
    console.log(
      "Place values filterd==>",
      place.address_components.filter((i, k) =>
        i.types.includes("street_number"),
      ),
    );
    var value = address?.split(",");
    const count = value.length;
    const country = value[count - 1];
    const stateVal = value[count - 2];
    const city = value[count - 3];
    const streetAdd = value[count - 4] !== undefined ? value[count - 4] : "";
    var stateSplit = stateVal?.split(" ");
    var i = stateSplit?.length;
    var pincode = "";
    const state =
      getShortNameAddressFromGoogleAutoComplete(
        place,
        "administrative_area_level_1",
      ) ||
      normalizeUsStateValue(stateSplit?.[1] || stateSplit?.[0]) ||
      stateSplit?.[1] ||
      "";
    if (i > 2) {
      pincode = stateSplit[2];
    } else if (!pincode) {
      pincode =
        getShortNameAddressFromGoogleAutoComplete(place, "postal_code") || "";
    }
    var ss = streetAdd?.split(" ");
    console.log(ss.length, "ss==>.", ss);
    const sn = place.address_components.filter((i, k) =>
      i.types.includes("street_number"),
    );
    var streetNum = sn.length > 0 ? sn[0]?.long_name : "";
    const sr = place.address_components.filter((i, k) =>
      i.types.includes("route"),
    );
    var site_route = sr.length > 0 ? sr[0]?.long_name : "";
    const condos = place.address_components.filter((i, k) =>
      i.types.includes("subpremise"),
    );
    var units = condos.length > 0 ? condos[0]?.long_name : "";
    var county = getShortNameAddressFromGoogleAutoComplete(
      place,
      "administrative_area_level_2",
    );
    var county_name = county?.replace("County", "").trim();

    var latitude = place.geometry.location.lat();
    var longitude = place.geometry.location.lng();
    let param = {
      street_number: streetNum,
      site_route: site_route,
      city: city,
      state: state,
      zip: pincode,
      unit_no: units,
      address: streetAdd,
      county: county_name,
    };
    let fixParams = {
      country: country,
      latitude: latitude,
      longitude: longitude,
      address: streetAdd,
    };
    console.log(county_name, "map lag==>>", param);
    setPropertyValues(param);
    setOtherPropertyValues(fixParams);

    const eldoradoRestrictionMessage = getEldoradoCountyRestrictionMessage({
      county: county_name,
      county_name,
    });
    if (eldoradoRestrictionMessage) {
      setErrMsg(eldoradoRestrictionMessage);
    } else {
      setErrMsg("");
    }
    // setPropertyForm(true);
    // setQuestionsErrMsg("");
    setShowPropertyListing(false);
  };

  const gotoQuestions = (data) => {
    const searchData = normalizePropertySearchPayload(data);
    console.log("go to questuionss==>", searchData);

    const eldoradoRestrictionMessage = getEldoradoCountyRestrictionMessage({
      county: searchData?.county || searchData?.county_name,
      county_name: searchData?.county_name || searchData?.county,
      county_code: searchData?.county_code,
      county_id: searchData?.county_id,
    });
    if (eldoradoRestrictionMessage) {
      setErrMsg(eldoradoRestrictionMessage);
      return;
    }

    setErrMsg("");
    setPropertySearchModeFromPayload(searchData);
    // onChangeModalScreen();
    dispatch(
      propertiesAction.fetchUserProperty({
        url: "properties",
        data: searchData,
      }),
    );
  };

  const addExistingAddress = () => {
    console.log(
      "addExistingAddress called",
      JSON.parse(localStorage.getItem("param")),
    );
    const searched_address = getObjLength(selectedRowData)
      ? selectedRowData?.searched_address
      : {};
    let param =
      JSON.parse(localStorage.getItem("param")) || searched_address?.param;
    let fixParams =
      JSON.parse(localStorage.getItem("fixParams")) ||
      searched_address?.fixed_params;
    setPropertyValues(param);
    setOtherPropertyValues(fixParams);
    setExistingAdd(
      localStorage.getItem("searched_Add") || searched_address?.full_address,
    );
    // setPropertyForm(true);
    setErrMsg("");
    setShowPropertyListing(false);
    setAddressPopup(false);
  };

  useEffect(() => {
    if (!isAdminCreateUser || editProperty) {
      return;
    }
    const storedSearchAdd = localStorage.getItem("searched_Add");
    if (storedSearchAdd) {
      setSearchedAddress(storedSearchAdd);
    }
  }, [isAdminCreateUser, editProperty]);

  useEffect(() => {
    dispatch(
      userSigupAction.getStateCode({ url: "get-states-code", data: {} }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (getObjLength(editPropertiesDetails)) {
      if (editPropertiesDetails?.success && editProperty) {
        setEditAdd(selectedData?.data);
      }
    }
  }, [editPropertiesDetails, editProperty, selectedData?.data]);

  useEffect(() => {
    console.log("Store data 44 ==>", getPropertyData);
    if (getPropertyData?.success) {
      if (getPropertyData?.data?.length === 1) {
        dispatch(
          propertiesAction.selectedUserPropertyData(getPropertyData?.data[0]),
        );
        // onBtnClick();
      } else {
        setTimeout(() => {
          handleClose();
        }, 3000);
      }
    } else {
      console.log("validate==>");
      validate();
    }
  }, [getPropertyData]);

  useEffect(() => {
    if (
      getObjLength(selectedRowData) &&
      getObjLength(selectedRowData?.searched_address) &&
      parseInt(selectedRowData?.properties_count) === 0
    ) {
      setAddressPopup(true);
    }
  }, [isResumeSignup]);

  useEffect(() => {
    if (
      getObjLength(getPropertyData) &&
      !getPropertyData?.success &&
      errMsg &&
      propertyErrorRef.current
    ) {
      propertyErrorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [getPropertyData, errMsg]);

  useEffect(() => {
    if (questionsErrMsg?.length > 0 && questionsErrorRef.current) {
      questionsErrorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [questionsErrMsg]);

  console.log(editProperty, "<==editProperty==selectedData==>", selectedData);

  return (
    <>
      {isTailwindComponent ? (
        <>
          <FindPropertyByAddressV2
            agreementCategory={agreementCategory}
            handleChange={handleChange}
            propertyValues={propertyValues}
            setPropertyValues={setPropertyValues}
            otherPropertyValues={otherPropertyValues}
            handleToggle={handleToggle}
            gotoQuestions={gotoQuestions}
            addExistingAddress={addExistingAddress}
            onBtnClick={onBtnClick}
            hasSearched={hasSearched}
            searchedAddress={searchedAddress}
            setSearchedAddress={setSearchedAddress}
            propertyQuestion={propertyQuestion}
            isPropertyConfirmed={isPropertyConfirmed}
            isByPassOptionAvailable={isByPassOptionAvailable}
            isAdminCreateUser={isAdminCreateUser}
            isServiceProvider={isServiceProvider}
            isAssistant={isAssistant}
            questionsErrMsg={questionsErrMsg}
            addPropertyError={errMsg}
            setAddPropertyError={setErrMsg}
            errMsg={errMsg}
          />
          {/* Visible copy is inside FindPropertyByAddressV2; keep scroll target */}
          {getObjLength(getPropertyData) && !getPropertyData?.success && (
            <span
              ref={propertyErrorRef}
              className="sr-only"
              aria-live="polite"
            >
              {errMsg}
            </span>
          )}

          {/* Visible error is rendered inside FindPropertyByAddressV2 */}
          {questionsErrMsg?.length > 0 && (
            <span ref={questionsErrorRef} className="sr-only" aria-live="polite">
              {questionsErrMsg}
            </span>
          )}
        </>
      ) : (
        <Box
          className="accountBoxWrapper bg-white"
          sx={{ pt: 2, pb: 0, px: "0 !important", mx: "0 !important" }}
        >
          {
            <>
              <>
                <Autocomplete
                  className="googleAutoComplete mw-100"
                  apiKey={GOOGLE_API_KEY}
                  value={existingAdd}
                  onChange={(e) => {
                    console.log("add", e);
                    setExistingAdd(e.target.value);
                  }}
                  onPlaceSelected={(place) => {
                    setExistingAdd(place?.formatted_address);
                    handleChange(place);
                  }}
                  libraries={["places"]}
                  options={{
                    types: ["address"],
                    componentRestrictions: { country: "us" },
                  }}
                  placeholder={`Enter ${
                    role?.includes(ROLES.admin) ||
                    role?.includes(ROLES.subAdmin)
                      ? "User's"
                      : "your"
                  } property address`}
                />
                <PropertyForm
                  propertyValues={propertyValues}
                  otherPropertyValues={otherPropertyValues}
                  onBtnClick={onBtnClick}
                  stateCodesData={stateCodesData}
                  gotoQuestions={gotoQuestions}
                  handleToggle={handleToggle}
                  isAdminCreateUser={isAdminCreateUser}
                  isServiceProvider={isServiceProvider}
                  isByPassOptionAvailable={isByPassOptionAvailable}
                  editProperty={editProperty}
                  selectedData={editAdd}
                  onCloseModalHandler={onCloseModalHandler}
                  isAssistant={isAssistant}
                  backToCategoryWisePricingScreen={
                    backToCategoryWisePricingScreen
                  }
                  isAdmin={isAdmin}
                />
              </>

              {getObjLength(getPropertyData) && !getPropertyData?.success && (
                <p
                  ref={propertyErrorRef}
                  className="text-danger text-center p-2"
                >
                  {errMsg}
                </p>
              )}

              {questionsErrMsg?.length > 0 && (
                <p ref={questionsErrorRef} className="text-danger text-center">
                  {questionsErrMsg}
                </p>
              )}
            </>
          }
        </Box>
      )}

      {/* {addressPopup && (
        <AlertDialog
          type="Attention"
          width="sm"
          openPopup={addressPopup}
          onClose={true}
          onCloseFun={() => setAddressPopup(false)}
          mesage={
            "  Would you like to use the address you've provided with the account?"
          }
          buttons={
            <>
              <Button
                className="popup_Btn other_popup_btn m-2"
                onClick={() => setAddressPopup(false)}
              >
                Nope
              </Button>
              <Button
                className="popup_Btn success_popup_btn "
                onClick={() => addExistingAddress()}
              >
                Yes
              </Button>
            </>
          }
        />
      )} */}

      <Loader open={statesLoader} />
    </>
  );
}
